/// <amd-module name="Build/Admin/Pool/Sources/ElasticPoolSource" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

import {
    ElasticNode,
    ElasticNodeSettings,
    ElasticNodeState,
    ElasticPool,
    ElasticPoolLog,
    ElasticPoolSettings
} from "DistributedTask/Client/Contracts/TaskAgent";
import { getElasticClient, IElasticRestClient } from "DistributedTask/Client/RestClient/Elastic";

import { ElasticPoolData } from "Build/Admin/Common/Client/Contracts/DistributedTask/DataProvider";
import { DataProviders } from "Build/Admin/Common/Constants";

export class ElasticPoolSource {
    private _client: IElasticRestClient;
    private _pageContext: IVssPageContext;
    private _elasticPoolData: ElasticPoolData | undefined;
    private _poolDataInitialized: boolean;

    constructor(pageContext: IVssPageContext) {
        this._pageContext = pageContext;
        this._client = getElasticClient(pageContext);
    }

    public getCachedSelectedElasticPoolData(): ElasticPoolData | undefined {
        this._initializeElasticPoolData();
        if (this._elasticPoolData) {
            return this._elasticPoolData;
        }
        else {
            return undefined;
        }
    }

    public async updateElasticPoolAsync(poolId: number, elasticPool: ElasticPoolSettings): Promise<ElasticPool> {
        return this._client.updateElasticPool(elasticPool, poolId);
    }

    public async getElasticPoolLogsAsync(elasticPool: ElasticPool): Promise<ElasticPoolLog[]> {
        return this._client.getElasticPoolLogs(elasticPool.poolId);
    }

    public async getElasticNodesAsync(elasticPool: ElasticPool, state?: ElasticNodeState | undefined): Promise<ElasticNode[]> {
        return this._client.getElasticNodes(elasticPool.poolId, state);
    }

    public async updateElasticNodeAsync(poolId: number, elasticNodeId: number, elasticNodeSettings: ElasticNodeSettings): Promise<ElasticNode> {
        return this._client.updateElasticNode(elasticNodeSettings, poolId, elasticNodeId);
    }

    private _initializeElasticPoolData(): void {
        if (!this._poolDataInitialized) {
            const contributionService: IVssContributionService = this._pageContext.getService<IVssContributionService>("IVssContributionService");
            this._elasticPoolData = contributionService.getData<ElasticPoolData>(DataProviders.ElasticPool);
            this._poolDataInitialized = true;
        }
    }
}
